import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_SERVICES](state, data) {
    state.allServices = data
  },
}
